import { FlagGroup } from '../index';

export default FlagGroup;
